import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import GallerySection from '../components/GallerySection';

export default function GalleryPage() {
  return (
    <>
      <SEOHead
        title="Galleri | Gribskovsmeden ApS"
        description="Galleri Her kan du se eksempler på det arbejde vi har udført for vores kunder Alle Altan Andet Hegn Kanter Konstruktioner Rækværk Skydeport Trapper"
      />

      {/* Header Banner */}
      <div className="bg-stone-950 text-white py-14 md:py-20 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 text-xs text-amber-400 font-semibold uppercase tracking-wider mb-3">
              <Link to="/" className="hover:text-amber-300">Forside</Link>
              <span>/</span>
              <span>Galleri</span>
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
              Galleri
            </h1>

            <p className="mt-3 text-lg sm:text-xl text-stone-300 font-medium">
              Her kan du se eksempler på det arbejde vi har udført for vores kunder
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-4 text-sm text-stone-300">
              <a
                href="tel:+4548796816"
                className="flex items-center gap-2 hover:text-white bg-stone-900/80 border border-stone-800 px-4 py-2 rounded-lg whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-amber-500" aria-hidden="true"></i>
                <span>+45 48 79 68 16</span>
              </a>
              <a
                href="mailto:lars@gribskovsmeden.dk"
                className="flex items-center gap-2 hover:text-white bg-stone-900/80 border border-stone-800 px-4 py-2 rounded-lg whitespace-nowrap"
              >
                <i className="fa-solid fa-envelope text-amber-500" aria-hidden="true"></i>
                <span>lars@gribskovsmeden.dk</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Gallery component with dynamic CMS integration */}
      <div className="bg-white">
        <GallerySection
          title=""
          subtitle=""
          showFilter={true}
        />
      </div>

      {/* Contact CTA */}
      <section className="py-14 bg-stone-100 border-t border-stone-200 text-center">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl font-bold text-stone-900">
            Har du et projekt eller en opgave?
          </h2>
          <p className="mt-2 text-stone-600 text-sm">
            Vi rådgiver og udarbejder gerne et uforpligtende tilbud på din næste opgave.
          </p>
          <div className="mt-6">
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-amber-600 hover:bg-amber-500 text-white font-bold text-sm rounded-lg transition-colors shadow-sm"
            >
              <span>Kontakt os i dag</span>
              <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
